import { FC, useState } from 'react';

import { IconButton, InputAdornment, SvgIcon, TextField, TextFieldProps } from '@mui/material';

import { ReactComponent as Visibility } from 'assets/icons/Visibility.svg';
import { ReactComponent as VisibilityHidden } from 'assets/icons/VisibilityHidden.svg';

import { inputAdornmentStyle, textFieldStyle } from './PasswordTextField.style';

export const PasswordTextField: FC<TextFieldProps> = ({ ...props }) => {
  const [isShowPassword, setIsShowPassword] = useState(false);
  const handleClickShowPassword = () => {
    setIsShowPassword((isShowPassword) => !isShowPassword);
  };
  return (
    <TextField
      {...props}
      type={!isShowPassword ? 'password' : 'text'}
      sx={{
        textFieldStyle,
        ...props.sx,
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end" sx={inputAdornmentStyle}>
            <IconButton disableRipple onClick={handleClickShowPassword}>
              <SvgIcon fontSize="small" component={isShowPassword ? VisibilityHidden : Visibility} inheritViewBox />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
